import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppInitService } from '../__init/app-init.service';
import { ReplaySubject } from 'rxjs';

export interface ShopifyVariant {
  variantId: string;
  product_ID: number;
  product: string;
  variantLabel: string;
}

export type ShopifyMap = Record<string, ShopifyVariant>;

@Injectable({
  providedIn: 'root'
})

export class ConfigService {
  private config: any = {};
  private storageKey = 'appConfig';
  private cacheDuration = 3600 * 1000; // 1 hour in milliseconds
  private baseDashboard;
  private baseWebapp;
  private authBase;
  private domainWebapp;
  private domainDashboard;
  //SHOPIFY
  private myShopUrl;
  private stockProductsFromShopify;
  
  private cfg$ = new ReplaySubject<any>(1);
  get config$() { return this.cfg$.asObservable(); }
  get snapshot() { let s; this.cfg$.subscribe(v => s = v).unsubscribe(); return s; }

  cachedConfig;
  cacheTime;

  constructor(private http: HttpClient,private appInit: AppInitService) {}
  
  loadConfig(){
    this.baseDashboard = this.appInit.snapshot.apiBaseUrlDashboard;
    this.authBase = this.appInit.snapshot.authUrlWebapp;
    this.baseWebapp = this.appInit.snapshot.apiBaseUrlWebapp;
    this.domainWebapp = this.appInit.snapshot.domainWebapp;
    this.domainDashboard = this.appInit.snapshot.domainDashboard;
    //SHOPIFY
    this.stockProductsFromShopify = this.appInit.snapshot.shopifyProducts;
    this.myShopUrl = this.appInit.snapshot.myShopUrl;
    //const productoTEST = this.appInit.getProduct('51822399947055'); // { product_ID: 60, product: 'Videollamada 60 minutos' }
  }

  loadConfigOld(): Promise<void> {
    return new Promise((resolve, reject) => {
      localStorage.getItem(this.storageKey)? this.cachedConfig = localStorage.getItem(this.storageKey) : this.cachedConfig = null;
      localStorage.getItem(`${this.storageKey}_timestamp`)? this.cacheTime = localStorage.getItem(`${this.storageKey}_timestamp`): this.cacheTime = null;

      if (false && this.cachedConfig && this.cacheTime && (Date.now() - Number(this.cacheTime) < this.cacheDuration)) {
        console.log('Using cached config');
        this.config = JSON.parse(this.cachedConfig);
        resolve();
      } else {
        console.log('Fetching config from server');
        this.http.get(this.baseDashboard+'config/apiConfig.php')
          .toPromise()
          .then(config => {
            this.config = config;
            localStorage.setItem(this.storageKey, JSON.stringify(config));
            localStorage.setItem(`${this.storageKey}_timestamp`, Date.now().toString());
            resolve();
          })
          .catch(error => {
            console.error("Error loading config:", error);
            reject(error);
          });
      }
    });
  }

  getStockProductsFromShopify(){
    return this.stockProductsFromShopify;
  }

  getApiUrl(key: string): string {
    return this.config[key] || '';
  }

  getBaseUrl(){
    return this.getApiUrlRefactor('appGet');
  }

  getAuthBase(){
    return this.authBase;
  }
  
  getApiUrlRefactor(label){
    switch(label){
      case 'domainWebapp':
        return this.domainWebapp;
      case 'domainDashboard':
        return this.domainDashboard;
      case 'auth':
        return this.authBase;
      case 'emailApp':
        return this.baseWebapp+'email/';
      case 'emailDash':
        return this.baseDashboard+'email/';
      case 'baseDashboard':
        return this.baseDashboard;
      case 'appBase':
        return this.baseWebapp;
      case 'appGet':
        return this.baseWebapp+'get/queryHandler.php';
      case 'myShopUrl':
        return this.myShopUrl;
      default:
        debugger
        return 'ERROR';
    }
  }

  findVariantBy(
    map: ShopifyMap = this.getStockProductsFromShopify(),
    searchBy: keyof ShopifyVariant,
    value: string | number
  ): ShopifyVariant | undefined {
    const target = String(value);
    return Object.values(map).find(v => String(v[searchBy]) === target);
}

  
}
